import { render } from "./BtnBack.vue?vue&type=template&id=3c722c1c&scoped=true"
import script from "./BtnBack.vue?vue&type=script&lang=js"
export * from "./BtnBack.vue?vue&type=script&lang=js"

import "./BtnBack.vue?vue&type=style&index=0&id=3c722c1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c722c1c"]])

export default __exports__